<template>
  <div>
    <div key="app">
      <NuxtLayout>
        <NuxtPage v-if="authUserData" />
        <ClientOnly>
          <Toast />
          <PwaUpdatePrompt />
        </ClientOnly>
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useStore } from '@/stores/store';
import { useMetaTitleService } from '~/composables/useMetaTitle';

const store = useStore();
const route = useRoute();
const usersStore = useUsersStore();
const { authUserData } = storeToRefs(usersStore);
const { fetchMe } = usersStore;

useMetaTitleService();
useHead({
  title: computed(() => String(route.meta.fullTitle ?? 'Goldorac')),
});

onMounted(() => {
  fetchMe();
});

// Mobile detection
const headers = useRequestHeaders();
const userAgent = headers?.['user-agent'] ?? navigator.userAgent;
store.userAgent = userAgent;
store.isMobile = userAgent.includes('Mobile') && screen.width <= 992 && window.matchMedia('(orientation: portrait)').matches;
</script>
